import styled from "styled-components";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import RowsJuegos from "./rowsJuegos.jsx"
import { visuallyHidden } from '@mui/utils';
import {useState,useEffect} from "react"
import { useSelector } from 'react-redux'




const Container = styled.div`
	width:99%;
	height:81vh;
  	display:flex;
  	justify-content:center;
  	
`;

const headCells = [
	{
    id: 'juego',
    numeric: false,
    disablePadding: false,
    label: 'juego',
  },
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: 'id',
  },
  {
    id: 'nombre',
    numeric: false,
    disablePadding: false,
    label: 'nombre dueño',
  },
  {
    id: 'usuario',
    numeric: false,
    disablePadding: false,
    label: 'usuario dueño',
  },
  {
    id: 'playstationID',
    numeric: false,
    disablePadding: false,
    label: 'playstation ID',
  },
  {
    id: 'correoPlaystation',
    numeric: false,
    disablePadding: false,
    label: 'correo playstation',
  },
  {
    id: 'fechaCreacion',
    numeric: false,
    disablePadding: false,
    label: 'fecha de adignacion',
  },
];


function formatFecha(fecha) {
  return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}




  function createData(reventa) {    
 
  return {
  			   id:reventa.id,
          	juegoConsola:reventa.consola,
          	juegoPoster:reventa.Cuenta_Juego.Juego.poster,
          	nombre:reventa.User.name,
          	usuario:reventa.User.usuario,
          	playstationID:reventa.Cuenta_Juego.Cuentum.playstation_id,
          	correoPlaystation:reventa.Cuenta_Juego.Cuentum.correo,
          	fechaCreacion:formatFecha(reventa.createdAt)
    };
}; 



function EnhancedTableHead(props) {
  const {  order, orderBy,  onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead >
      <TableRow>
        
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sx={{fontSize:"14px"}}

            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}

            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align="right" sx={{fontSize:"14px"}}>Revender</TableCell>
             
      </TableRow>
    </TableHead>
  );
}

 


//---------------------------------------------------- inicio de componente--------------------------------------------------------------
export default function UsersTable(props){

  let reventasRedux=useSelector(state=>state.reventa.reventas);
	const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('fechaCreacion');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows,setRows] = useState([]);
 


 function EnhancedTableToolbar(props) {
  
  return (
    <Toolbar>     
        <Typography sx={{ flex: '1 1 100%' }} variant="h4" id="tableTitle" component="div" >
          Juegos
        </Typography>   
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


  useEffect(()=>{
    let dataFilter=reventasRedux.filter(reventa=>!reventa.publicar_reventa);
    let rowsprops = dataFilter.map(reventa=>createData(reventa));
    console.log(rowsprops)
    setRows(rowsprops);
  },[reventasRedux])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

 
	return(
		<Container style={{marginBottom:"55px",width:"100%"}}>	
			<Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer  sx={{
          maxHeight: "64vh",
          overflowY: "scroll", // Asegura que la barra aparezca solo cuando sea necesario
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#555",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#222",
          },
        }}>
          <Table
            sx={{ minWidth: "93vw" }}
            aria-labelledby="tableTitle"
            size='medium'
            stickyHeader
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              <RowsJuegos rows={rows} order={order} orderBy ={orderBy} page={page} rowsPerPage={rowsPerPage} />

              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height:  53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
 
    </Box>
		</Container>


		)
}